import { apiClient } from "./apiClient";
import { API_BASE_URL } from "../config";

export const fleetService = {
  listVehicles: () => apiClient.get("/fleet/vehicles").then((r) => r.data),

  getVehicle: (id, from, to) =>
    apiClient
      .get(`/fleet/vehicles/${id}`, { params: { from, to } })
      .then((r) => r.data),

  createVehicle: (payload) =>
    apiClient.post("/fleet/vehicles", payload).then((r) => r.data),

  updateVehicle: (id, payload) =>
    apiClient.put(`/fleet/vehicles/${id}`, payload).then((r) => r.data),

  deleteVehicle: (id) => apiClient.delete(`/fleet/vehicles/${id}`),

  uploadVehicleImage: (id, file) => {
    const fd = new FormData();
    fd.append("image", file);
    return apiClient
      .post(`/fleet/vehicles/${id}/image`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  createReservation: (payload) =>
    apiClient.post("/fleet/reservations", payload).then((r) => r.data),

  updateReservation: (id, payload) =>
    apiClient.put(`/fleet/reservations/${id}`, payload).then((r) => r.data),

  participantCandidates: () =>
    apiClient.get("/fleet/reservations/candidates").then((r) => r.data),

  myReservations: () =>
    apiClient.get("/fleet/reservations/my").then((r) => r.data),

  allReservations: (params = {}) =>
    apiClient.get("/fleet/reservations", { params }).then((r) => r.data),

  cancelReservation: (id) =>
    apiClient.delete(`/fleet/reservations/${id}`),

  approveReservation: (id) =>
    apiClient.post(`/fleet/reservations/${id}/approve`),

  rejectReservation: (id) =>
    apiClient.post(`/fleet/reservations/${id}/reject`),
};

export const vehicleImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (/^https?:\/\//.test(imagePath)) return imagePath;
  return `${API_BASE_URL}/fleet/assets/${imagePath.replace(/^\/+/, "")}`;
};
